import { Link } from "react-router-dom";
import { AlertTriangle, CheckCircle2, ExternalLink, FileText, Loader2, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const when = (ts) => new Date(ts * 1000).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

const Status = ({ job }) => {
  if (job.status === "done") {
    return <span className="inline-flex items-center gap-1.5 text-emerald-700"><CheckCircle2 className="h-4 w-4" /> {job.summary.count} movimenti</span>;
  }
  if (job.status === "processing") {
    const pct = job.total ? Math.round((job.done / job.total) * 100) : 0;
    return <span className="inline-flex items-center gap-1.5 text-sky-700"><Loader2 className="h-4 w-4 animate-spin" /> In corso · {pct}%</span>;
  }
  return <span className="inline-flex items-center gap-1.5 text-red-600"><AlertTriangle className="h-4 w-4" /> Non riuscita</span>;
};

export const HistoryItem = ({ id, job, onRemove }) => (
  <li data-testid={`history-item-${id}`} className="flex flex-col gap-3 px-5 py-4 sm:flex-row sm:items-center">
    <FileText className="hidden h-5 w-5 shrink-0 text-slate-400 sm:block" />
    <div className="min-w-0 flex-1">
      <p data-testid={`history-name-${id}`} className="truncate font-medium text-slate-900">{job.filename}</p>
      <p className="mt-0.5 text-xs text-slate-500">
        {job.file_count} file · avviata {when(job.created)}
      </p>
    </div>
    <div data-testid={`history-status-${id}`} className="text-sm font-medium"><Status job={job} /></div>
    <div className="flex gap-2">
      {job.status !== "error" ? (
        <Button asChild size="sm" data-testid={`history-open-${id}`} className="rounded-full bg-slate-900 text-white hover:bg-slate-800">
          <Link to={`/tabella/${id}`}><ExternalLink className="mr-1.5 h-3.5 w-3.5" /> Apri</Link>
        </Button>
      ) : (
        <span data-testid={`history-error-${id}`} className="max-w-xs truncate text-xs text-slate-500" title={job.error}>{job.error}</span>
      )}
      <Button size="sm" variant="ghost" data-testid={`history-remove-${id}`} onClick={() => onRemove(id)} title="Togli dallo storico" className="text-slate-400 hover:text-red-600">
        <X className="h-4 w-4" />
      </Button>
    </div>
  </li>
);
